import { DefaultFullPreview } from "..";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { CheckoutFormSection } from "../../../CheckoutFormSection";

export interface ProratedCreditPreviewProps {
  className?: string;
  preview: PaywallCheckoutPreview;
}

export const ProratedCreditPreview = ({
  preview,
  className,
}: ProratedCreditPreviewProps) => {
  const {
    prorated_credit_description: proratedCreditDescription,
    prorated_credit_amount: proratedCreditAmount,
    formatted_prorated_credit_amount: formattedProratedCreditAmount,
  } = preview.first_payment;

  if (!proratedCreditDescription || proratedCreditAmount === 0) {
    return null;
  }

  return (
    <CheckoutFormSection className={classNames("gap-y-1 border-t", className)}>
      <DefaultFullPreview.PreviewEntry
        label={t("paywall_checkout.prorated_credit")}
        labelWeight="semibold"
        value={formattedProratedCreditAmount}
        valueColor={
          proratedCreditAmount < 0 ? "text-green-600" : "text-primary"
        }
        dataTestId="checkout-form-preview-prorated-credit"
      />
      <Typography.LabelXs>{proratedCreditDescription}</Typography.LabelXs>
    </CheckoutFormSection>
  );
};
